// src/context/DataCacheContext.js
import React, { createContext, useContext, useState } from 'react';

const DataCacheContext = createContext();

export const useDataCache = () => {
  const context = useContext(DataCacheContext);
  if (!context) {
    throw new Error('useDataCache must be used within DataCacheProvider');
  }
  return context;
};

export const DataCacheProvider = ({ children }) => {
  const [cache, setCacheState] = useState({});  // Renamed to avoid conflict

  const getCached = (key) => {
    return cache[key];
  };

  const setCache = (key, data) => {  // This function name is fine now
    setCacheState(prev => ({
      ...prev,
      [key]: {
        data,
        timestamp: Date.now()
      }
    }));
  };

  const isCacheValid = (key, maxAge = 60000) => { // Default 60 seconds
    const cached = cache[key];
    if (!cached) return false;
    return (Date.now() - cached.timestamp) < maxAge;
  };

  const clearCache = (key) => {
    if (key) {
      setCacheState(prev => {
        const newCache = { ...prev };
        delete newCache[key];
        return newCache;
      });
    } else {
      setCacheState({});
    }
  };

  return (
    <DataCacheContext.Provider value={{ getCached, setCache, isCacheValid, clearCache }}>
      {children}
    </DataCacheContext.Provider>
  );
};